import { Component } from '@angular/core';
import { BaseMediaPlayerDirective } from 'src/app/directives/base-media-player.directive';

@Component({
  selector: 'app-aws-video-player',
  templateUrl: './aws-video-player.component.html',
  styleUrls: ['./aws-video-player.component.sass'],
})
export class AwsVideoPlayerComponent extends BaseMediaPlayerDirective {}
